// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","wrap":"Layout_wrap__WHN0h","content":"Layout_content__UOgH6","collapsecontent":"Layout_collapsecontent__F7SKH"};